import { extract } from '../extractors/unlock';
import { fmtUSD, fmtPct } from '../extractors/_shared';

const txt = (lang, zh, en) => (lang === 'en' ? en : zh);

export function buildHtml(project, a, lang = 'zh') {
  const d = extract(project, a);
  if (!d || !d.events.length) return '';

  const allocSorted = [...d.allocations].sort((a, b) => (b?.amount || 0) - (a?.amount || 0));
  const max = allocSorted[0]?.amount || 1;
  const allocRows = allocSorted.slice(0, 8).map(a => {
    const pct = ((a?.amount || 0) / max) * 100;
    const isRisky = /team|invest|insider|advisor|founder|early/i.test(a?.name || '');
    return `
      <div style="margin-bottom:6px">
        <div style="display:flex;justify-content:space-between;font-size:11px;margin-bottom:2px">
          <span style="color:${isRisky ? '#dc2626' : '#111827'};font-weight:${isRisky ? 600 : 500}">${a?.name || ''}</span>
          <span style="color:#6b7280;font-family:monospace">${fmtUSD(a?.amount)}</span>
        </div>
        <div style="height:5px;background:#f3f4f6;border-radius:3px;overflow:hidden">
          <div style="width:${pct}%;height:100%;background:${isRisky ? '#dc2626' : '#2563eb'}"></div>
        </div>
      </div>`;
  }).join('');

  const eventRows = d.events.slice(0, 12).map(e => {
    const urgent = e?.daysFromNow >= 0 && e?.daysFromNow <= 30;
    return `
      <tr style="border-bottom:1px solid #f3f4f6;background:${urgent ? '#fef9c3' : 'transparent'}">
        <td style="padding:5px 8px;font-family:monospace;font-size:11px">${e?.date || ''}</td>
        <td style="padding:5px 8px;text-align:right;color:${urgent ? '#dc2626' : '#6b7280'};font-weight:${urgent ? 700 : 400};font-size:11px">${e?.daysFromNow < 0 ? '—' : e?.daysFromNow + 'd'}</td>
        <td style="padding:5px 8px;text-align:right;font-weight:600;font-size:11px">${fmtUSD(e?.totalAmount)}</td>
        <td style="padding:5px 8px;font-size:10px;color:#6b7280">${(e?.allocations || []).slice(0, 3).map(a => a?.name).filter(Boolean).join(', ') || '—'}</td>
      </tr>`;
  }).join('');

  return `
<div style="border:1px solid #e5e7eb;border-radius:10px;overflow:hidden;margin-bottom:14px">
  <div style="padding:13px 16px;background:#fafafa;border-bottom:1px solid #f3f4f6;font-size:13px;font-weight:800;color:#111827;display:flex;justify-content:space-between;align-items:center">
    <span>🔓 ${txt(lang, '详细代币解锁日程', 'Detailed Unlock Schedule')}</span>
    <span style="font-weight:400;font-size:10px;color:#94a3b8">Surf</span>
  </div>
  <div style="padding:14px 16px">
    ${d.next30dAmount > 0 ? `
      <div style="margin-bottom:12px;padding:8px 10px;background:#fef3c7;border-radius:6px;border:1px solid #fde68a">
        <div style="font-size:10px;color:#92400e;font-weight:700">⚠️ ${txt(lang, '未来30日解锁量', 'Next 30 Days Unlock')}</div>
        <div style="font-size:14px;font-weight:700;color:#92400e">${fmtUSD(d.next30dAmount)}${d.next30dRatio != null ? ' · ' + fmtPct(d.next30dRatio, 2) : ''}</div>
      </div>` : ''}
    ${allocRows ? `
      <div style="font-size:10px;font-weight:700;color:#6b7280;margin-bottom:6px;text-transform:uppercase">${txt(lang, '分配类别（全周期总量）', 'Allocation Breakdown')}</div>
      ${allocRows}` : ''}
    <div style="font-size:10px;font-weight:700;color:#6b7280;margin:14px 0 8px;text-transform:uppercase">${txt(lang, '即将到来的解锁事件', 'Upcoming Unlock Events')}</div>
    <table style="width:100%;font-size:11px;border-collapse:collapse">
      <thead><tr style="background:#f9fafb">
        <th style="padding:5px 8px;text-align:left;color:#6b7280;font-size:10px">${txt(lang, '日期', 'Date')}</th>
        <th style="padding:5px 8px;text-align:right;color:#6b7280;font-size:10px">${txt(lang, '剩余天', 'In Days')}</th>
        <th style="padding:5px 8px;text-align:right;color:#6b7280;font-size:10px">${txt(lang, '解锁量', 'Amount')}</th>
        <th style="padding:5px 8px;text-align:left;color:#6b7280;font-size:10px">${txt(lang, '分配', 'Allocations')}</th>
      </tr></thead>
      <tbody>${eventRows}</tbody>
    </table>
  </div>
</div>`;
}
